// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StartRecordingPopup__container-e45aa7 {
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/StartRecordingPopup/StartRecordingPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".container {\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StartRecordingPopup__container-e45aa7`
};
module.exports = ___CSS_LOADER_EXPORT___;
